// extracted by mini-css-extract-plugin
export default {"errorWrapper":"styles_errorWrapper__cmvZ1"};